module.exports = __webpack_public_path__ + "img/6_76.0c3d79ce.png";